import { render, staticRenderFns } from "./StaffProfile.vue?vue&type=template&id=72650f2c&scoped=true"
import script from "./StaffProfile.vue?vue&type=script&lang=js"
export * from "./StaffProfile.vue?vue&type=script&lang=js"
import style0 from "./StaffProfile.vue?vue&type=style&index=0&id=72650f2c&prod&scoped=true&lang=css"
import style1 from "./StaffProfile.vue?vue&type=style&index=1&id=72650f2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72650f2c",
  null
  
)

export default component.exports